import { createContext, useContext } from 'react'

/** What the reader chose. `system` is the absence of a choice, not a third theme. */
export type ThemePreference = 'system' | 'light' | 'dark'

/** What is actually on screen. Always one of two. */
export type ResolvedTheme = 'light' | 'dark'

export interface ThemeContextValue {
  readonly preference: ThemePreference
  readonly resolved: ResolvedTheme
  readonly setPreference: (preference: ThemePreference) => void
}

export const ThemeContext = createContext<ThemeContextValue | null>(null)

export function useTheme(): ThemeContextValue {
  const value = useContext(ThemeContext)
  if (value === null) {
    throw new Error('useTheme must be used within <ThemeProvider>.')
  }
  return value
}

/** Shared with `public/theme-init.js`, which runs before this module exists. */
export const THEME_STORAGE_KEY = 'pushcaster.theme'
